const translations = {
  "en": {
    "Address Used:": "Address Used:",
    "Available": "Available",
    "Choose Token and Network": "Choose Token and Network",
    "Connect Wallet": "Connect Wallet",
    "Crypto": "Crypto",
    "Payment method": "Payment method",
    "Switch wallet": "Switch wallet"
  },
  "zh-tw": {
    "Address Used:": "使用地址：",
    "Available": "可用",
    "Choose Token and Network": "選擇代幣和網路",
    "Connect Wallet": "連接錢包",
    "Crypto": "加密貨幣",
    "Payment method": "付款方式",
    "Switch wallet": "切換錢包"
  }
};

export default translations;
